import React, { useEffect, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import AlertWaiting from '../../molecules/AlertWaiting'

const API_URL = 'https://moovery.app/api/indique_ganhe/index.php'
const ROTA_LOGIN = '/parceiro'
const ROTA_PAINEL = '/painel'

const PERFIL_CONFIG = {
  parceiro: { storageKey: 'parceiroData' },
  empresa:  { storageKey: 'empresaData'  },
  motoboy:  { storageKey: 'motoboyData'  },
}

export default function Autologin() {
  const history = useHistory()
  const location = useLocation()
  const [mensagem, setMensagem] = useState('Autenticando seu acesso...')

  useEffect(() => {
    const params = new URLSearchParams(location.search)
    const token = params.get('token')

    if (!token) {
      history.push(ROTA_LOGIN)
      return
    }

    const autenticarToken = async () => {
      try {
        const response = await fetch(API_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            method: 'validarAutologinToken',
            data: { token }
          })
        })

        const res = await response.json()

        if (res.success && res.tipo_perfil && res.dados) {
          const config = PERFIL_CONFIG[res.tipo_perfil] || PERFIL_CONFIG.empresa

          Object.values(PERFIL_CONFIG).forEach(c => localStorage.removeItem(c.storageKey))

          localStorage.setItem(config.storageKey, JSON.stringify(res.dados))
          localStorage.setItem('userTipoPerfil', res.tipo_perfil)

          history.push(ROTA_PAINEL)
        } else {
          setMensagem(res.message || 'Token de autologin inválido ou expirado.')
          setTimeout(() => {
            history.push(ROTA_LOGIN)
          }, 2500)
        }
      } catch (err) {
        console.error('Erro no autologin:', err)
        setMensagem('Erro de conexão ao autenticar.')
        setTimeout(() => {
          history.push(ROTA_LOGIN)
        }, 2500)
      }
    }

    autenticarToken()
  }, [history, location.search])

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      fontFamily: 'sans-serif',
      backgroundColor: '#f8f5fc',
      color: '#333'
    }}>
      <AlertWaiting />
      <p style={{ marginTop: '20px', fontSize: '1.1rem', fontWeight: 500 }}>
        {mensagem}
      </p>
    </div>
  )
}
